module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sl-box"
  }, [_c('div', {
    staticClass: "revenu",
    class: _vm.classObject
  }, [_c('div', {
    staticClass: "sl-cnt"
  }, [_c('span', [_vm._v(_vm._s(_vm.value))])]), _vm._v(" "), _c('div', {
    staticClass: "sl-title"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1a13cf94!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/sl-box.vue
// module id = 1085
// module chunks = 1